import React from 'react';
import { LinksProps } from './';

export const FooterLinks: React.FC<LinksProps> = ({ links }: LinksProps) => {
  return (
    <>
      {links?.map((link, index) => (
        <a
          key={index}
          href={link.url}
          target={link.target ?? '_self'}
          className="footer__link"
        >
          {link.text}
        </a>
      ))}
    </>
  );
};
